export function getStyleString(element) {

  const options = element.options;
  const style = `

    #${options?.id}:hover {
        background-color: ${options?.hoverBackgroundColor};
        color: ${options?.hoverTextColor};
      }
  `;

  return style;

}

function getStyleBlockId(element) {

  return `${element.options?.id}-style`;

}

export function deleteStyleBlock(element) {

  const styleBlock = document.getElementById(getStyleBlockId(element));

  styleBlock.parentNode.removeChild(styleBlock);

}

export function addStyleBlock(element) {

  const styleBlockId = getStyleBlockId(element);

  document.head.insertAdjacentHTML('beforeend', `<style id="${styleBlockId}">${getStyleString(element)}</style>`);

}

export function updateStyleBlock(element) {

  deleteStyleBlock(element);

  addStyleBlock(element);

}